import { createInjectionKey as e } from "../../_utils/vue/create-injection-key.js";
const n = e("n-tree");
export {
  n as treeInjectionKey
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/tree/src/interface.js
// module id = 271
// module chunks = 67